<template>
  <div id="headersFornedores">
    <div
      v-if="loading"
      :style="styleObject"
      class="text-center"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div
      v-else
    >
      <br><br><br>
      <v-row>
        <v-col
          cols="12"
        >
          <v-btn
            id="btnPrint"
            class="cols-12 sm-3 md-3 lg-1"
            small
            dark
            :disabled="enableBtn"
            :color="corPrimaria"
            :loading="imprimindo"
            @click="exportExcel()"
          >
            <v-icon>
              mdi-printer
            </v-icon>
            Exporta Excel
            <template v-slot:loader>
              <span>Gerando...</span>
            </template>
          </v-btn>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="6"
        >
          <div
            id="idTable"
            style="overflow-x: auto;"
          >
            <table
              style="width: 100%; color: black; border-collapse: collapse;"
              class="elevation-1"
            >
              <thead>
                <tr>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                  >
                    Produtos
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                  >
                    Variação
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                  >
                    Percentual
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                  >
                    Preço Médio
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                  >
                    Diferença Tabela 2
                  </th>
                </tr>
              </thead>
              <tbody
                v-for="item in dadosComparativoTabelas"
                :key="item.id"
              >
                <tr>
                  <td
                    id="dadoMovimentacao"
                    style="text-align: left;"
                  >
                    {{ item.produto }}
                  </td>
                  <td
                    id="dadoMovimentacao"
                    class="text-right"
                    :style="getColor(item.variacao)"
                  >
                    {{ getVariacao(item.variacao) }}
                  </td>
                  <td
                    id="dadoMovimentacao"
                    class="text-right"
                    :style="getColor(item.percentual)"
                  >
                    {{ getPercentual(item.percentual) }}
                  </td>
                  <td
                    id="dadoMovimentacao"
                    style="text-align: right;"
                  >
                    {{ item.precoMedio }}
                  </td>
                  <td
                    id="dadoMovimentacao"
                    class="text-right"
                    :style="getColor(item.diferencaPreco)"
                  >
                    {{ getVariacao(item.diferencaPreco) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="6"
        >
          <div
            id="idTable"
            style="overflow-x: auto;"
          >
            <table
              style="width: 100%; color: black; border-collapse: collapse;"
              class="elevation-1"
            >
              <thead>
                <tr>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                  >
                    Produtos
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                  >
                    Variação
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                  >
                    Percentual
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                  >
                    Preço Médio
                  </th>
                </tr>
              </thead>
              <tbody
                v-for="item in dadosPrecoMedio"
                :key="item.id"
              >
                <tr>
                  <td
                    id="dadoMovimentacao"
                    style="text-align: left;"
                  >
                    {{ item.produto }}
                  </td>
                  <td
                    id="dadoMovimentacao"
                    class="text-right"
                    :style="getColor(item.variacao)"
                  >
                    {{ getVariacao(item.variacao) }}
                  </td>
                  <td
                    id="dadoMovimentacao"
                    class="text-right"
                    :style="getColor(item.percentual)"
                  >
                    {{ getPercentual(item.percentual) }}
                  </td>
                  <td
                    id="dadoMovimentacao"
                    style="text-align: right;"
                  >
                    {{ item.precoMedio }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  import PrecoMedio from '../../../../services/precomedio'
  import eventEmit from '../core/EventoEmit'
  import ExcelJS from 'exceljs'
  import { saveAs } from 'file-saver'

  export default {
    name: 'ShowDadosComparativoFaturamento',
    emits: ['setDadosPrecoMedio'],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      corPrimaria: '#2863af',
      error: null,
      dataInicial: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresaSelect: [],
      cidades: [],
      redes: [],
      areas: [],
      vendedores: [],
      clientes: [],
      produtos: [],
      linhas: [],
      caixas: [],
      dataInicial2: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal2: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresaSelect2: [],
      cidades2: [],
      redes2: [],
      areas2: [],
      vendedores2: [],
      clientes2: [],
      produtos2: [],
      linhas2: [],
      caixas2: [],
      segmento: [],
      segmento1: [],
      headersComparativoTabelas: [
        { text: 'Produtos', value: 'produto', align: 'left', class: 'black--text title' },
        { text: 'Variação', value: 'variacao', align: 'right', class: 'black--text title' },
        { text: 'Percentual', value: 'percentual', align: 'right', class: 'black--text title' },
        { text: 'Preço Médio', value: 'precoMedio', align: 'right', class: 'black--text title' },
        { text: 'Diferença Tabela 2', value: 'diferencaPreco', align: 'right', class: 'black--text title' },
      ],
      headersPrecoMedio: [
        { text: 'Produtos', value: 'produto', align: 'left', class: 'black--text title' },
        { text: 'Variação', value: 'variacao', align: 'right', class: 'black--text title' },
        { text: 'Percentual', value: 'percentual', align: 'right', class: 'black--text title' },
        { text: 'Preço Médio', value: 'precoMedio', align: 'right', class: 'black--text title' },
      ],
      dadosComparativoTabelas: [],
      dadosPrecoMedio: [],
      dadosComparativoTabelasExcel: [],
      dadosPrecoMedioExcel: [],
      tituloRelatorio: 'Relatório Preço Médio',
      arquivo: 'relatorio_preco_medio.xlsx',
      enableBtn: true,
      imprimindo: false,
    }),

    created () {
      eventEmit.$on('update-form-mais-vida', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-form-mais-vida', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (dataInicial, dataFinal, empresaSelect, cidadeSelect, areaSelect, vendedorSelect, redeSelect, produtoSelect, linhaSelect, clienteSelect, caixaSelect, dataInicial1, dataFinal1, empresaSelect1, cidadeSelect1, areaSelect1, vendedorSelect1, redeSelect1, produtoSelect1, linhaSelect1, clienteSelect1, caixaSelect1, segmento, segmento1) {
        this.dataInicial = dataInicial
        this.dataFinal = dataFinal
        this.empresaSelect = empresaSelect
        this.cidades = cidadeSelect
        this.areas = areaSelect
        this.vendedores = vendedorSelect
        this.redes = redeSelect
        this.produtos = produtoSelect
        this.linhas = linhaSelect
        this.clientes = clienteSelect
        this.caixas = caixaSelect
        this.dataInicial2 = dataInicial1
        this.dataFinal2 = dataFinal1
        this.empresaSelect2 = empresaSelect1
        this.cidades2 = cidadeSelect1
        this.areas2 = areaSelect1
        this.vendedores2 = vendedorSelect1
        this.redes2 = redeSelect1
        this.produtos2 = produtoSelect1
        this.linhas2 = linhaSelect1
        this.clientes2 = clienteSelect1
        this.caixas2 = caixaSelect1
        this.segmento = segmento
        this.segmento1 = segmento1

        this.atualizaDados()
      },

      async atualizaDados () {
        this.loading = true
        this.dadosComparativoTabelas = []
        this.dadosPrecoMedio = []
        this.dadosComparativoTabelasExcel = []
        this.dadosPrecoMedioExcel = []
        this.enableBtn = true

        await PrecoMedio.showDadosComparativoPrecoMedio(this.dataInicial, this.dataFinal, this.empresaSelect, this.cidades, this.produtos, this.areas, this.vendedores, this.redes, this.caixas, this.dataInicial2, this.dataFinal2, this.empresaSelect2, this.cidades2, this.produtos2, this.areas2, this.vendedores2, this.redes2, this.caixas2, localStorage.tokencontrato, this.segmento, this.segmento1).then(resposta => {
          if (resposta.data.status) {
            this.enableBtn = false

            this.dadosComparativoTabelas = resposta.data.dadosTabela1.map((item) => {
              var listaDadosFaturamento = ({
                produto: item.produto,
                precoMedio: item.precoMedio ? parseFloat(item.precoMedio).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '-',
                diferencaPreco: item.diferenca ? item.diferenca : '-',
                variacao: item.variacao ? item.variacao : '-',
                percentual: item.percentual ? item.percentual : '-',
              })

              return listaDadosFaturamento
            })

            this.dadosPrecoMedio = resposta.data.dadosTabela2.map((item) => {
              var listaDados = ({
                produto: item.produto,
                precoMedio: parseFloat(item.precoMedio).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                variacao: item.variacao ? item.variacao : '-',
                percentual: item.percentual ? item.percentual : '-',
              })

              return listaDados
            })

            this.dadosComparativoTabelasExcel = resposta.data.dadosTabela1.map((item) => {
              var listaDadosFaturamento = ({
                produto: item.produto,
                variacao: item.variacao ? parseFloat(item.variacao).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '-',
                percentual: item.percentual ? parseFloat(item.percentual).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%' : '-',
                precoMedio: item.precoMedio ? parseFloat(item.precoMedio).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '-',
                diferencaPreco: item.diferenca ? parseFloat(item.diferenca).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '-',
              })

              return listaDadosFaturamento
            })

            this.dadosPrecoMedioExcel = resposta.data.dadosTabela2.map((item) => {
              var listaDados = ({
                produto: item.produto,
                variacao: item.variacao ? parseFloat(item.variacao).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '-',
                percentual: item.percentual ? parseFloat(item.percentual).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%' : '-',
                precoMedio: parseFloat(item.precoMedio).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              })

              return listaDados
            })

            eventEmit.$emit('set-dados-preco-medio', this.dadosComparativoTabelas, this.dadosPrecoMedio)
          } else if (resposta.data.msg === 'Não dados de valores a pagar para fornecedores no período selecionado') {
            this.dadosFaturamento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      getColor (value) {
        if (value < 0) {
          return 'color: red'
        } else if (value > 0) {
          return 'color: green'
        }
      },

      getVariacao (value) {
        return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      },

      getPercentual (value) {
        if (value !== '-') {
          return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%'
        }

        return '-'
      },

      async exportExcel () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.printExcel()
          }, 2000)
        } catch (error) {
          console.error('Erro ao exportar excel', error)
        }
      },

      async printExcel () {
        try {
          const workbook = new ExcelJS.Workbook()
          const worksheet = workbook.addWorksheet('Relatório Preço Médio')

          // tituloRelatorio: 'Relatório Preço Médio',
          // arquivo: '',

          let posY = 1

          const inserirTitulo = (worksheet) => {
            // Adicionar Título
            worksheet.mergeCells(`A${posY}:E${posY}`)
            worksheet.getCell(`A${posY}`).value = 'Filtros selecionados tabela 1'
            worksheet.getCell(`A${posY}`).font = { size: 14, bold: true }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            worksheet.mergeCells(`H${posY}:L${posY}`)
            worksheet.getCell(`H${posY}`).value = 'Filtros selecionados tabela 2'
            worksheet.getCell(`H${posY}`).font = { size: 14, bold: true }
            worksheet.getCell(`H${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            posY += 2

            const dataInicial = this.dataInicial.substr(8) + '/' + this.dataInicial.substr(5, 2) + '/' + this.dataInicial.substr(0, 4)
            const ultimoDia = this.dataFinal.substr(8) + '/' + this.dataFinal.substr(5, 2) + '/' + this.dataFinal.substr(0, 4)
            worksheet.mergeCells(`A${posY}:D${posY}`)
            worksheet.getCell(`A${posY}`).value = `Data inicial: ${dataInicial} - Data final: ${ultimoDia}`
            worksheet.getCell(`A${posY}`).font = { size: 10 }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            const dataInicial2 = this.dataInicial.substr(8) + '/' + this.dataInicial.substr(5, 2) + '/' + this.dataInicial.substr(0, 4)
            const ultimoDia2 = this.dataFinal.substr(8) + '/' + this.dataFinal.substr(5, 2) + '/' + this.dataFinal.substr(0, 4)
            worksheet.mergeCells(`H${posY}:L${posY}`)
            worksheet.getCell(`H${posY}`).value = `Data inicial: ${dataInicial2} - Data final: ${ultimoDia2}`
            worksheet.getCell(`H${posY}`).font = { size: 10 }
            worksheet.getCell(`H${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            posY += 2

            const adicionarFiltros = (worksheet, posY, titulo, dados) => {
              if (dados.length > 0) {
                const texto = titulo + ' ' + dados.join(', ')

                worksheet.mergeCells(`A${posY}:D${posY}`)
                worksheet.getCell(`A${posY}`).value = texto
                worksheet.getCell(`A${posY}`).font = { size: 10 }
                worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

                return posY + 1
              }
              return posY
            }

            const adicionarFiltros2 = (worksheet, posY, titulo, dados) => {
              if (dados.length > 0) {
                const texto = titulo + ' ' + dados.join(', ')

                worksheet.mergeCells(`H${posY}:L${posY}`)
                worksheet.getCell(`H${posY}`).value = texto
                worksheet.getCell(`H${posY}`).font = { size: 10 }
                worksheet.getCell(`H${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

                return posY + 1
              }
              return posY
            }

            posY = adicionarFiltros(worksheet, posY, 'Empresa(s) Selecionada(s):', this.empresaSelect.map(e => e.empresaSelect))
            posY = adicionarFiltros2(worksheet, posY, 'Empresa(s) Selecionada(s):', this.empresaSelect2.map(e => e.empresaSelect))

            posY = adicionarFiltros(worksheet, posY, 'Cidade(s) Selecionada(s):', this.cidades.map(e => e.cidade))
            posY = adicionarFiltros2(worksheet, posY, 'Cidade(s) Selecionada(s):', this.cidades2.map(e => e.cidade))

            posY = adicionarFiltros(worksheet, posY, 'Área(s) Selecionada(s):', this.areas.map(a => a.area))
            posY = adicionarFiltros2(worksheet, posY, 'Área(s) Selecionada(s):', this.areas2.map(a => a.area))

            posY = adicionarFiltros(worksheet, posY, 'Rede(s) Selecionada(s):', this.redes.map(r => r.rede))
            posY = adicionarFiltros2(worksheet, posY, 'Rede(s) Selecionada(s):', this.redes2.map(r => r.rede))

            posY = adicionarFiltros(worksheet, posY, 'Vendedor(es) Selecionado(s):', this.vendedores.map(v => v.vendedor))
            posY = adicionarFiltros2(worksheet, posY, 'Vendedor(es) Selecionado(s):', this.vendedores2.map(v => v.vendedor))

            posY = adicionarFiltros(worksheet, posY, 'Produto(s) Selecionado(s):', this.produtos.map(p => p.produto))
            posY = adicionarFiltros2(worksheet, posY, 'Produto(s) Selecionado(s):', this.produtos2.map(p => p.produto))

            posY = adicionarFiltros(worksheet, posY, 'Segmento(s) Selecionado(s):', this.segmento.map(se => se.segmento))
            posY = adicionarFiltros2(worksheet, posY, 'Segmento(s) Selecionado(s):', this.segmento1.map(se => se.segmento))

            posY = adicionarFiltros(worksheet, posY, 'Caixa(s) Selecionada(s):', this.caixas.map(cx => cx.caixa))
            posY = adicionarFiltros2(worksheet, posY, 'Caixa(s) Selecionada(s):', this.caixas2.map(cx => cx.caixa))

            posY += 1
          }

          posY += 1

          inserirTitulo(worksheet)

          // Adicionar a primeira tabela
          const tableHeaders1 = this.headersComparativoTabelas.map(header => header.text)
          const tableData1 = this.dadosComparativoTabelasExcel.map(item => [
            item.produto,
            item.variacao,
            item.percentual,
            item.precoMedio,
            item.diferencaPreco,
          ])

          tableHeaders1.forEach((header, index) => {
            worksheet.getCell(posY, index + 1).value = header
            worksheet.getCell(posY, index + 1).font = { bold: true }
          })
          tableData1.forEach((row, rowIndex) => {
            row.forEach((cell, colIndex) => {
              worksheet.getCell(posY + rowIndex + 1, colIndex + 1).value = cell
            })
          })

          // Sincronizar linha da segunda tabela com a primeira
          const posYSecondTable = posY
          const colStartSecondTable = 8

          const tableHeaders2 = this.headersPrecoMedio.map(header => header.text)
          const tableData2 = this.dadosPrecoMedioExcel.map(item => [
            item.produto,
            item.variacao,
            item.percentual,
            item.precoMedio,
            item.diferencaPreco,
          ])

          tableHeaders2.forEach((header, index) => {
            worksheet.getCell(posYSecondTable, colStartSecondTable + index).value = header
            worksheet.getCell(posYSecondTable, colStartSecondTable + index).font = { bold: true }
          })

          tableData2.forEach((row, rowIndex) => {
            row.forEach((cell, colIndex) => {
              worksheet.getCell(posYSecondTable + rowIndex + 1, colStartSecondTable + colIndex).value = cell
            })
          })

          const buffer = await workbook.xlsx.writeBuffer()
          saveAs(new Blob([buffer]), 'relatorio_preco_medio.xlsx')
        } catch (error) {
          console.error('Erro ao gerar Excel:', error)
        } finally {
          this.imprimindo = false
        }
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
      max-width: 401px !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }

  #text1 {
    margin: 0 0 0 47rem;
  }

  #text2 {
    margin: 0 0 0 11.5rem;
  }

  #textTable {
    font-size: 0.9rem !important
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }
</style>
